// Knock workflow keys that announce the outcome of a Live Link setup.
// Standard (Oncor/CenterPoint) setups announce with the original key. Dual
// signups (standard + Pro created together) suppress the standard
// notification and announce through the SMT keys instead, so every listener
// has to accept all three or dual-signup users never hear that setup
// finished. Success is still decided by data.is_success on the notification.
export const LIVE_LINK_SETUP_RESULT_KEYS = [
  'live-link-initial-setup-complete',
  'live-link-smt-initial-setup-complete',
  'live-link-smt-initial-setup-error'
]
